/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    xander<luoxingzhang@frippler.com>
  | @Title:     请求协议、资料审核
  | @Version:   2020-07-15  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function eiProtocolApi() {
  return request({
    url: '?c=ei&a=agreement&do=getprotocol',
    method: 'get'
  })
}

export function eiGetfileApi() {
  return request({
    url: '?c=ei&a=agreement&do=gettpl',
    method: 'get'
  })
}
export function eiSendApi(data) {
  return request({
    url: '?c=module&a=open&do=apply',
    method: 'post',
    data: data
  })
}
